module.exports = {"fr-FR":{"components":{"paginator":{"first":"Accueil","prev":"Précédent(e)","next":"Suivant(e)","last":"Fin"}}}}